import '@widesk-ui/components/styles/Values.scss';

import View             from '@widesk-ui/components/View';
import useTheme         from '@widesk-ui/hooks/useTheme';
import React            from 'react';
import { ValueProps }   from '@widesk-ui/components/Value';
import Value            from '@widesk-ui/components/Value';
import Icon             from '@widesk-ui/components/Icon';
import Observer         from '@widesk-ui/components/Observer';
import _uniqueId        from 'lodash/uniqueId';
import { CopyOutlined } from '@ant-design/icons';

type DatumProps = {
	icon?: React.ReactNode | string;
	label?: React.ReactNode;
	vertical?: boolean;
} & ValueProps<any>;

type ValuesOptions = {
	rowGap?: number;
}

export type ColumnRow = DatumProps & { hidden?: boolean };
export type Column = ColumnRow[];
export type Columns = Column[];

export type ValuesProps = {
	columns: Columns | (() => Columns); // Utiliser une fonction pour que le contenu soit observé
	options?: ValuesOptions;
	widthF?: boolean;
	renderRightColumn?: React.ReactNode;
};

export default function Values(props: ValuesProps) {
	const { options } = props;

	const theme = useTheme();
	const uniqueId = React.useMemo(() => `widesk-values-${_uniqueId()}`, []);

	return (
		<Observer render={() => {
			const columns = typeof props.columns === 'function' ? props.columns() : props.columns;

			return (
				<View id={uniqueId} className="widesk-values" row gap={theme.marginMD} splitSeparator top wrap widthF={props.widthF}>
					{columns.map((column, columnIdx) => {
						return (
							<View key={columnIdx} style={{ display: 'table' }} widthF={props.widthF}>
								{column
									.filter(data => !data.hidden)
									.map((data, dataIdx) => {
										const { vertical } = data;
										const rowGapAttributes = options?.rowGap && dataIdx >= 1
											? { paddingTop: options?.rowGap }
											: {};

										const content = (
											<div
												className={`widesk-values-column ${data.enableCopy ? 'copy-enabled' : ''}`}
												id={`widesk-values-column-${dataIdx}`}
												key={dataIdx}
												style={{ display: vertical ? undefined : 'table-row' }}
											>
												{!!data.label && (
													<div
														onClick={data.enableCopy ? () => {
															const values = document.getElementById(uniqueId);
															const column = values?.querySelector(`#widesk-values-column-${dataIdx}`);
															const value = column?.querySelector(` .widesk-value`);
															return (value as HTMLElement).click();
														} : undefined}
														style={{ display: vertical ? undefined : 'table-cell', ...rowGapAttributes }}
													>
														<View color={theme.colorTextLabel} className="label" row gap={6} noWrap centerV inline>
															{data.enableCopy &&
																<CopyOutlined className="widesk-values-column-copyIcon" style={{ display: 'none' }} />}
															{!!data.icon && (
																typeof data.icon === 'string' ? <Icon name={data.icon} /> : data.icon
															)}
															{data.label} :&nbsp;
														</View>
													</div>
												)}

												<div style={{ display: vertical ? undefined : 'table-cell', verticalAlign: 'middle', ...rowGapAttributes }}>
													<Value {...data} />
												</div>
											</div>
										);

										return props.renderRightColumn ? (
											<View row spread widthF marginB="sm" key={dataIdx}>
												<div>{content}</div>
												<div>{props.renderRightColumn}</div>
											</View>
										) : content;
									})}
							</View>
						);
					})}
				</View>
			);
		}} />
	);
}
